import { useMemo } from "react";
import { FORM_PANEL_STACK_BREAKPOINT } from "./conversationConstants";

export default function useConversationRightPanel({
  activeFormContext,
  activeFileContext,
  showTaskQueueToggle,
  taskQueuePanelOpen,
  activeRightTab,
  isFormFullscreen,
  isFileFullscreen,
  taskQueueExpandedMode,
  taskQueuePanelWidth,
  filePanelWidth,
  formPanelWidth,
  splitContainerWidth,
}) {
  const availableRightTabs = useMemo(() => {
    const tabs = [];
    if (activeFormContext) tabs.push("form");
    if (activeFileContext) tabs.push("file");
    if (showTaskQueueToggle && taskQueuePanelOpen) tabs.push("taskQueue");
    return tabs;
  }, [
    activeFormContext,
    activeFileContext,
    showTaskQueueToggle,
    taskQueuePanelOpen,
  ]);

  const rightPanelOpen =
    availableRightTabs.length > 0 && activeRightTab !== null;
  const showRightPanelTabBar = availableRightTabs.length >= 1;
  const isRightPanelFullscreen =
    (activeRightTab === "form" && isFormFullscreen) ||
    (activeRightTab === "file" && isFileFullscreen) ||
    (activeRightTab === "taskQueue" && taskQueueExpandedMode);
  const rightPanelWidth =
    activeRightTab === "taskQueue"
      ? taskQueuePanelWidth
      : activeRightTab === "file"
      ? filePanelWidth
      : formPanelWidth;
  const shouldStackRightPanel =
    rightPanelOpen &&
    !isRightPanelFullscreen &&
    splitContainerWidth !== null &&
    splitContainerWidth < FORM_PANEL_STACK_BREAKPOINT;

  return {
    availableRightTabs,
    rightPanelOpen,
    showRightPanelTabBar,
    isRightPanelFullscreen,
    rightPanelWidth,
    shouldStackRightPanel,
  };
}
